import type { PropsWithChildren } from 'react'

import clsx from 'clsx'
import styled from 'styled-components'

export type CardFooterProps = PropsWithChildren<{
  className?: string
}>

const Container = styled.div`
  opacity: 1;
  transition: all 0.3s ease;
`

const CardFooter = ({ children, className = '' }: CardFooterProps) => {
  return <Container className={clsx('card-footer', className)}>{children}</Container>
}

export default CardFooter
